<template>
  <div class="social-step-editor-sidebar-media-uploading">
    <shared-step-editor-loader :size="50" />
    <span>UPLOADING</span>
  </div>
</template>

<script>
import SharedStepEditorLoader from '../../shared/SharedStepEditorLoader';

export default {
  components: {
    SharedStepEditorLoader,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.social-step-editor-sidebar-media-uploading {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border: 1px dashed $color-regent-grey;
  color: $color-regent-grey;
  padding: 10px 0;
  font-weight: bold;
}
</style>
